"use strict";

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUpdatingState = exports.useUpdatingRef = void 0;

var react_1 = __importDefault(require("react"));
/**
 * This is similar to `useFreshRef()` except it takes a setter function, and allows
 * you to control the dependencies. It also ensures the ref _always_ has a value, even
 * once it's initialized.
 *
 * Typically, if you have a ref and a `useEffect()` that updates it, the ref won't have
 * a value until the effect runs, which is typically after the component renders the
 * first time. The way to get around that, historically, was to use the same logic as the
 * default value of the ref _and_ inside the `useEffect`, which requires duplicating code.
 *
 * Here, we have a helper function that means you don't need to duplicate your code anymore.
 * @param setter the setter function to generate the value
 * @param deps the deps for `useEffect`
 * @returns the ref
 */


function useUpdatingRef(setter, deps) {
  var ref = react_1.default.useRef(setter());
  react_1.default.useEffect(function () {
    ref.current = setter();
  }, deps);
  return ref;
}

exports.useUpdatingRef = useUpdatingRef;

function useUpdatingState(setter, deps) {
  var _react_1$default$useS = react_1.default.useState(setter()),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      state = _react_1$default$useS2[0],
      setState = _react_1$default$useS2[1];

  react_1.default.useEffect(function () {
    setState(setter());
  }, deps);
  return [state, setState];
}

exports.useUpdatingState = useUpdatingState;